import { styled, FormControl as FormControl$1, selectClasses, svgIconClasses, paperClasses, listClasses, MenuItem as MenuItem$1, Select as Select$1 } from "@mui/material";
import { getTextFieldStyles } from "../../utils/shared/TextField.js";
const FormControl = styled(FormControl$1)(({ theme }) => {
  return {
    ...getTextFieldStyles({ theme }),
    [`& .${selectClasses.select}`]: {
      "&:focus": {
        backgroundColor: "transparent"
      }
    },
    [`& .${svgIconClasses.root}.${selectClasses.icon}.${selectClasses.iconOutlined}`]: {
      zIndex: 2
    },
    [`& .${paperClasses.root}`]: {
      maxHeight: 48 * 4.5,
      borderRadius: "0px 0px 4px 4px"
    },
    [`& .${listClasses.root}`]: {
      padding: 0
    }
  };
});
const MenuItem = styled(MenuItem$1)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  fontSize: theme.spacing(2),
  "&.Mui-selected, &.Mui-selected:hover": {
    backgroundColor: theme.palette.grey[100]
  }
}));
const Select = styled(Select$1)({});
export {
  FormControl,
  MenuItem,
  Select
};
